module.exports = __webpack_public_path__ + "img/login-splash-lr.69c3f8df.jpg";